import { MdPersonSearch, MdEvent, MdSchedule, MdPayment } from 'react-icons/md';
import { t } from '../../utils/i18n';
import familyImage from '../../assets/landing/family-home-care.jpg';

const FEATURES = [
  { num: '01', key: 'profiles', icon: MdPersonSearch },
  { num: '02', key: 'schedule', icon: MdEvent },
  { num: '03', key: 'hours', icon: MdSchedule },
  { num: '04', key: 'payments', icon: MdPayment },
];

export default function FeaturesSection() {
  return (
    <section className="landing-section landing-section--warm">
      <div className="landing-container">
        <div className="landing-features-split">
          <figure className="landing-features-photo">
            <img
              src={familyImage}
              alt={t('landing.features.imageAlt')}
              loading="lazy"
              width="1200"
              height="900"
            />
          </figure>

          <div className="landing-features-copy">
            <h2 className="landing-section-title">{t('landing.features.title')}</h2>
            <p className="landing-section-subtitle">{t('landing.features.subtitle')}</p>

            <div className="landing-features-list">
              {FEATURES.map(({ num, key, icon: Icon }) => (
                <article key={key} className="landing-features-item">
                  <div className="landing-features-item-head">
                    <span className="landing-features-num" aria-hidden="true">{num}</span>
                    <span className="landing-features-icon" aria-hidden="true">
                      <Icon />
                    </span>
                  </div>
                  <h3 className="landing-features-item-title">
                    {t(`landing.features.${key}.title`)}
                  </h3>
                  <p className="landing-features-item-desc">
                    {t(`landing.features.${key}.description`)}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
